module.exports = __webpack_public_path__ + "static/media/callLight.83a0899c.svg";